/**
 * Graphique à barres horizontales simple
 * data: [{ label, value }]
 */
export default function BarChart({
  title,
  data = [],
  colors = ["#203a8a", "#3b82f6", "#8b5cf6", "#10b981", "#f59e0b", "#ef4444", "#ec4899", "#06b6d4"],
  loading = false,
  emptyMessage = "Aucune donnée disponible",
  valueFormatter = (v) => v,
}) {
  const maxValue = Math.max(...data.map((d) => d.value || 0), 1)

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
      {title && (
        <h3 className="text-lg font-semibold text-[#203a8a] mb-4">{title}</h3>
      )}
      {loading ? (
        <div className="flex items-center justify-center h-48">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#203a8a]"></div>
        </div>
      ) : data.length === 0 ? (
        <div className="flex items-center justify-center h-48 text-gray-500 text-sm">
          {emptyMessage}
        </div>
      ) : (
        <div className="space-y-3">
          {data.map((item, index) => {
            const width = (item.value / maxValue) * 100
            const color = colors[index % colors.length]
            return (
              <div key={index}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-medium text-gray-700 truncate max-w-[60%]">
                    {item.label}
                  </span>
                  <span className="text-sm font-semibold text-gray-900">
                    {valueFormatter(item.value)}
                  </span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-2 overflow-hidden">
                  <div
                    className="h-2 rounded-full transition-all duration-500"
                    style={{ width: `${width}%`, backgroundColor: color }}
                  />
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
